module.exports = __webpack_public_path__ + "img/126.7330a24e.jpg";